import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'primereact/carousel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import BannerCarousel from '../components/BannerCarousel';
import ProductCard from '../components/ProductCard';
import CategoryList from '../components/CategoryList';
// import BrandShowcase from '../components/BrandShowcase'; // Comentado por el momento
import { EcommerceProductoService } from '../services/EcommerceProductoService';

const EcommerceHome = () => {
    const navigate = useNavigate();
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const idEmpresa = 1; // ID de la empresa (configurar según tu sistema)

    // Cargar productos del backend - SIN FALLBACK A MOCKDATA
    useEffect(() => {
        const loadProducts = async () => {
            try {
                setError(null);
                const response = await EcommerceProductoService.obtenerProductos(idEmpresa);
                setAllProducts(response || []);
            } catch (error) {
                setError(`Error cargando productos: ${error.message}`);
                setAllProducts([]);
            } finally {
                setLoading(false);
            }
        };

        loadProducts();
    }, []);

    // Usar SOLO productos del backend
    const featuredProducts = allProducts.slice(0, 8);
    const newProducts = allProducts.slice(8, 16);
    const smartphones = allProducts.filter(p => p.idCategoria === 1 || p.nombre?.toLowerCase().includes('smartphone'));
    const gaming = allProducts.filter(p => p.idCategoria === 6 || p.nombre?.toLowerCase().includes('gaming'));

    const productResponsiveOptions = [
        { breakpoint: '1400px', numVisible: 4, numScroll: 1 },
        { breakpoint: '1024px', numVisible: 3, numScroll: 1 },
        { breakpoint: '768px', numVisible: 2, numScroll: 1 },
        { breakpoint: '560px', numVisible: 1, numScroll: 1 }
    ];

    const productTemplate = (product) => (
        <div style={{ padding: '0 10px' }}>
            <ProductCard product={product} />
        </div>
    );

    if (loading) {
        return (
            <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                <ProgressSpinner />
            </div>
        );
    }

    if (error) {
        return (
            <div className="ec-container" style={{ padding: '20px 0' }}>
                <Message severity="error" text={error} style={{ width: '100%' }} />
            </div>
        );
    }

    return (
        <div>
            {/* HERO BANNER */}
            <div className="ec-section" style={{ paddingBottom: 0 }}>
                <div className="ec-container">
                    <BannerCarousel />
                </div>
            </div>

            {/* OFERTAS EN SMARTPHONES */}
            {smartphones.length > 0 && (
                <div className="ec-section">
                    <div className="ec-container">
                        <div className="ec-section-header">
                            <h2 className="ec-section-title">
                                Ofertas en <span>Smartphones</span>
                            </h2>
                            <span
                                className="ec-section-link"
                                onClick={() => navigate('/tienda/catalogo?cat=smartphones')}
                            >
                                Ver todos <i className="pi pi-angle-right"></i>
                            </span>
                        </div>
                        <Carousel
                            value={smartphones}
                            itemTemplate={productTemplate}
                            numVisible={5}
                            numScroll={1}
                            responsiveOptions={productResponsiveOptions}
                            className="ec-product-carousel"
                        />
                    </div>
                </div>
            )}

            {/* CATEGORÍAS */}
            <CategoryList />

            {/* MARCAS DESTACADAS - COMENTADO POR EL MOMENTO */}
            {/* <BrandShowcase /> */}

            {/* PRODUCTOS NUEVOS */}
            {newProducts.length > 0 && (
                <div className="ec-section">
                    <div className="ec-container">
                        <div className="ec-section-header">
                            <h2 className="ec-section-title">
                                Recién <span>Llegados</span>
                            </h2>
                            <span
                                className="ec-section-link"
                                onClick={() => navigate('/tienda/catalogo')}
                            >
                                Ver todos <i className="pi pi-angle-right"></i>
                            </span>
                        </div>
                        <Carousel
                            value={newProducts}
                            itemTemplate={productTemplate}
                            numVisible={5}
                            numScroll={1}
                            responsiveOptions={productResponsiveOptions}
                            className="ec-product-carousel"
                        />
                    </div>
                </div>
            )}

            {/* GAMING */}
            {gaming.length > 0 && (
                <div className="ec-section" style={{ background: '#fff' }}>
                    <div className="ec-container">
                        <div className="ec-section-header">
                            <h2 className="ec-section-title">
                                <i className="pi pi-bolt" style={{ color: 'var(--ec-primary)', marginRight: 8 }}></i>
                                Gaming y <span>Entretenimiento</span>
                            </h2>
                            <span
                                className="ec-section-link"
                                onClick={() => navigate('/tienda/catalogo?cat=gaming')}
                            >
                                Ver todos <i className="pi pi-angle-right"></i>
                            </span>
                        </div>
                        <Carousel
                            value={gaming}
                            itemTemplate={productTemplate}
                            numVisible={5}
                            numScroll={1}
                            responsiveOptions={productResponsiveOptions}
                            className="ec-product-carousel"
                        />
                    </div>
                </div>
            )}

            {/* PRODUCTOS RECOMENDADOS - GRID */}
            {featuredProducts.length > 0 && (
                <div className="ec-section">
                    <div className="ec-container">
                        <div className="ec-section-header">
                            <h2 className="ec-section-title">
                                Productos <span>Recomendados</span>
                            </h2>
                            <span
                                className="ec-section-link"
                                onClick={() => navigate('/tienda/catalogo')}
                            >
                                Ver todos <i className="pi pi-angle-right"></i>
                            </span>
                        </div>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                            gap: 20
                        }}>
                            {featuredProducts.slice(0, 8).map(product => (
                                <ProductCard key={product.id} product={product} />
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* BANNER CTA */}
            <div className="ec-section" style={{ paddingBottom: 0 }}>
                <div className="ec-container">
                    <div
                        style={{
                            background: 'var(--ec-gradient-primary)',
                            borderRadius: 'var(--ec-radius-lg)',
                            padding: '48px 56px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            color: '#fff',
                            flexWrap: 'wrap',
                            gap: 24
                        }}
                    >
                        <div>
                            <h2 style={{ fontSize: '1.8rem', fontWeight: 800, marginBottom: 8, margin: 0 }}>
                                ¿No encuentras lo que buscas?
                            </h2>
                            <p style={{ opacity: 0.9, fontSize: '1rem', margin: 0 }}>
                                Explora nuestro catálogo completo con más de 100 productos tecnológicos
                            </p>
                        </div>
                        <button
                            className="ec-banner-cta"
                            onClick={() => navigate('/tienda/catalogo')}
                            style={{
                                cursor: 'pointer',
                                padding: '14px 36px',
                                borderRadius: 50,
                                fontWeight: 700,
                                fontSize: '1rem',
                                background: '#fff',
                                color: 'var(--ec-primary)',
                                border: 'none'
                            }}
                        >
                            <i className="pi pi-th-large" style={{ marginRight: 8 }}></i>
                            Ver catálogo completo
                        </button>
                    </div>
                </div>
            </div>

            {/* Spacer before footer */}
            <div style={{ height: 48 }}></div>
        </div>
    );
};

export default EcommerceHome;
